import { TextareaProps } from '@apia/theme';
import { ValidatedCollectorField } from '../ValidatedCollectorField';
import { Textarea } from '../../components';

export class CollectorTextarea extends ValidatedCollectorField<
  string,
  Omit<TextareaProps, 'name'>
> {
  type = 'textarea';

  Component = () => {
    const rules = this.useValidationRules();
    const validationFunction = this.useValidationFunction();
    const props = this.useProperties();

    return (
      <Textarea
        {...props}
        initialValue={this.config.initialValue}
        name={this.name}
        validationFunction={validationFunction}
        validationRules={rules}
        label={this.label}
      />
    );
  };
}
